<template>
  <div class="card" id="lighting">
    <nav class="fixed-bar navbar navbar-expand-lg navbar-light" color="white">
      <h3 class="navbar-brand">Lighting</h3>
      <!-- <add-character-model
        @save="saveSetDesign"
        @open="openDialog"
        @close="closeDialog"
        v-bind:dialog="dialog"
        v-bind:info="editedItem"
        v-bind:edited-i-d="editedID">
      </add-character-model> -->
      <add-lighting
        @save="saveSetDesign"
        @open="openDialog"
        @close="closeDialog"
        v-bind:dialog="dialog"
        v-bind:info="editedItem"
        v-bind:edited-i-d="editedID">
      </add-lighting>
    </nav>
    <hr/>
    <div class="container fluid grid-list-lg">
      <asset-table
        v-bind:updated="updated"
        v-bind:asset_type="asset_type"
        @edit="editItem"
        v-bind:headers="headers"
        >

      </asset-table>
    </div>
  </div>
</template>

<script>
  import AddLighting from './add-new/addLighting'
  import {db, assetMediaStorageRef, assetModelStorageRef} from '../../firebaseDB'
  import AssetTable from './assetTable'

  export default {
    // name: 'character-model',
    name: 'lighting',
    components: {AssetTable, AddLighting},
    data: () => ({
      fileType: {
        image: 'image',
        file: 'file'
      },
      asset_type: 'set_lighting',
      headers: [
        {th: 'Name', name: 'name'},
        {th: 'Date Uploaded', name: 'date_uploaded'},
        // {th: 'Date Modified', name: 'date_modified'},
        {th: 'Uploaded By', name: 'creator'},
        {th: 'Target', name: 'target'},
        {th: 'Type Of Light', name: 'typeOfLight'}
      ],
      dialog: '',
      updated: false,
      editedItem: {
        id: null,
        name: '',
        description: '',
        image: null,
        typeOfMedia: '',
        typeOfImage: 'Background',
        videoLink: '',
        Media: {
          fileName: '',
          file: '',
          fileURL: ''
        }
      },
      defaultItem: {
        id: null,
        name: '',
        duration: 0,
        typeOfLight: '',
        target: '',
        range: '',
        positionOfOrigin: {
          X: 0,
          Y: 0,
          Z: 0
        },
        rotationOfOrigin: {
          X: 0,
          Y: 0,
          Z: 0
        },
        intensity: '',
        shadowType: '',
        shadowStrength: '',
        description: '',
        image: null,
        typeOfImage: 'Background',
        videoLink: '',
        Media: {
          fileName: '',
          file: '',
          fileURL: ''
        }
      },
      editedID: -1,
      editedIndex: -1,
      tableData: []
    }),
    // created () {
    //   this.initialize()
    // },
    methods: {
      saveSetDesign (updatedData) {
        console.log(updatedData)
        const currentdate = new Date()
        const datetime = currentdate.getDate() + '/' +
          (currentdate.getMonth() + 1) + '/' +
          currentdate.getFullYear() + ' @ ' +
          currentdate.getHours() + ':' +
          currentdate.getMinutes() + ':' +
          currentdate.getSeconds()
        setTimeout(() => {
          let updates = {}
          let requireDefaultUpdate = true
          if (!updatedData.id) {
            updatedData.id = db.ref(`asset_data/${this.asset_type}/`).push().key
            updates[`asset_data/${this.asset_type}/${updatedData.id}/meta_data/creator`] = this.$store.state.user.email
            updates[`asset_data/${this.asset_type}/${updatedData.id}/meta_data/date_uploaded`] = datetime
          }
          updates[`asset_data/${this.asset_type}/${updatedData.id}/description`] = updatedData.description || ''
          updates[`asset_data/${this.asset_type}/${updatedData.id}/typeOfMedia`] = updatedData.typeOfMedia || ''
          updates[`asset_data/${this.asset_type}/${updatedData.id}/name`] = updatedData.name || ''
          updates[`asset_data/${this.asset_type}/${updatedData.id}/duration`] = updatedData.duration || ''
          updates[`asset_data/${this.asset_type}/${updatedData.id}/typeOfLight`] = updatedData.typeOfLight || ''
          updates[`asset_data/${this.asset_type}/${updatedData.id}/target`] = updatedData.target || ''
          updates[`asset_data/${this.asset_type}/${updatedData.id}/range`] = updatedData.range || ''
          updates[`asset_data/${this.asset_type}/${updatedData.id}/positionOfOrigin`] = {
            X: updatedData.positionOfOrigin.X || '0',
            Y: updatedData.positionOfOrigin.Y || '0',
            Z: updatedData.positionOfOrigin.Z || '0'
          }
          updates[`asset_data/${this.asset_type}/${updatedData.id}/rotationOfOrigin`] = {
            X: updatedData.rotationOfOrigin.X || '0',
            Y: updatedData.rotationOfOrigin.Y || '0',
            Z: updatedData.rotationOfOrigin.Z || '0'
          }
          updates[`asset_data/${this.asset_type}/${updatedData.id}/intensity`] = updatedData.intensity || ''
          updates[`asset_data/${this.asset_type}/${updatedData.id}/shadowType`] = updatedData.shadowType || ''
          updates[`asset_data/${this.asset_type}/${updatedData.id}/shadowStrength`] = updatedData.shadowStrength || ''

          if (updatedData.typeOfMedia === 'image') {
            updates[`asset_data/${this.asset_type}/${updatedData.id}/typeOfImage`] = updatedData.typeOfImage || 'Background'
          }
          if (updatedData.typeOfMedia === 'video') {
            updates[`asset_data/${this.asset_type}/${updatedData.id}/videoLink`] = updatedData.videoLink || ''
          }

          updates[`asset_data/${this.asset_type}/${updatedData.id}/meta_data/date_modified`] = datetime
          if (this.shouldUpload(this.fileType.image, updatedData)) {
            this.uploadImage(updatedData, updates)
            requireDefaultUpdate = false
          }
          if (this.shouldUpload(this.fileType.file, updatedData)) {
            // this.uploadFBX(updatedData, updates)
            this.uploadFile(updatedData, updates)
            requireDefaultUpdate = false
          }
          if (requireDefaultUpdate) {
            db.ref('assets').update(updates).then(snapshot => {
              this.closeDialog()
              this.updated = true
            })
          }
        }, 500)
        this.updated = false
      },
      shouldUpload (fileType, updatedData) {
        if (fileType === this.fileType.image) {
          return updatedData.image && updatedData.image.imageFile
        } else if (fileType === this.fileType.file) {
          return updatedData.Media && updatedData.Media.file
        }
      },
      uploadImage (updatedData, updates) {
        assetMediaStorageRef.child(`${updatedData.id}.jpg`)
          .put(updatedData.image.imageFile)
          .then(snapshot => snapshot.ref.getDownloadURL())
          .catch(function (error) {
            console.log(`Error - ${error.message}`)
          })
          .then((url) => {
            updatedData.image.imageURL = url
          })
          .catch(function (error) {
            console.log(`Error - ${error.message}`)
          })
          .then(snapshot => {
            updates[`asset_data/${this.asset_type}/${updatedData.id}/image`] = updatedData.image || {imageURL: '', imageFile: ''}
            console.log('Your image file is saved in storage')
            db.ref('assets').update(updates)
              .then(snapshot => {
                this.closeDialog()
                this.updated = true
                console.log('Your image fileURL is saved in assets')
              })
          })
          .catch(function (error) {
            console.log('Error - ' + error.message)
          })
      },
      uploadFile (updatedData, updates) {
        if (updatedData.Media && updatedData.Media.file) {
          assetModelStorageRef.child(`${updatedData.id}/Media`)
            .put(updatedData.Media.file)
            .then(snapshot => snapshot.ref.getDownloadURL())
            .catch(function (error) {
              console.log(`Error - ${error.message}`)
            })
            .then((url) => {
              updatedData.Media.fileURL = url
              console.log('Transferring Media file url')
            })
            .then(snapshot => {
              let key = `asset_data/${this.asset_type}/${updatedData.id}/Media`
              updates[key] = updatedData.Media || {
                fileURL: '',
                file: ''
              }
              console.log(`Your Media file is saved in storage`)
              db.ref('assets').update(updates)
                .then(snapshot => {
                  this.closeDialog()
                  this.updated = true
                  console.log(`Your Media fileURL is saved in assets`)
                })
            })
        }
      },
      // uploadFBX (updatedData, updates) {
      //   assetModelStorageRef.child(`${updatedData.id}/original.fbx`)
      //     .put(updatedData.fbx.file)
      //     .then(snapshot => snapshot.ref.getDownloadURL())
      //     .catch(function (error) {
      //       console.log(`Error - ${error.message}`)
      //     })
      //     .then((url) => {
      //       updatedData.fbx.fileURL = url
      //       console.log('Transferring file url')
      //     })
      //     .then(snapshot => {
      //       updates[`asset_data/${this.asset_type}/${updatedData.id}/fbx`] = updatedData.fbx || {
      //         fileURL: '',
      //         file: ''
      //       }
      //       console.log('Your fbx file is saved in storage')
      //       db.ref('assets').update(updates)
      //         .then(snapshot => {
      //           this.closeDialog()
      //           this.updated = true
      //           console.log('Your fbx fileURL is saved in assets')
      //         })
      //     })
      // },
      openDialog () {
        this.dialog = true
      },
      closeDialog () {
        this.editedID = -1
        this.editedIndex = -1
        this.editedItem = Object.assign({}, this.defaultItem)
        this.dialog = false
      },
      editItem (item) {
        this.editedIndex = item.index
        this.editedID = item.id
        this.editedItem = item.item
        if (!this.editedItem.hasOwnProperty('positionOfOrigin')) {
          this.editedItem.positionOfOrigin = {
            X: 0,
            Y: 0,
            Z: 0
          }
        }
        if (!this.editedItem.hasOwnProperty('rotationOfOrigin')) {
          this.editedItem.rotationOfOrigin = {
            X: 0,
            Y: 0,
            Z: 0
          }
        }
        this.dialog = true
      }
    }
  }
</script>

<style scoped>
#twoDMedia{
  scroll-margin: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/assets/lighting.vue